import React, { useEffect, useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import 'react-datetime/css/react-datetime.css';
import Order from '../../Model/models/orderModel';
import './orderForm.scss';
import constants from '../../constants';
import Loader from '../../common-components/loader';
import {
  // Checkbox,
  message,
  notification
} from 'antd';
import OrderPayment from '../../Model/Payment';
import OrderFormHeader from '../../Components/Purchases/orderForm/components/orderFormHeader';
import OrderFormBody from '../../Components/Purchases/orderForm/components/orderFormBody';
import { OrdersService } from '../../services/ordersService';
import Contact from '../../Model/models/contactModel';
import Location from '../../Model/models/locationModel';
import { useTranslation } from 'react-i18next';
import { OrderFormUtils } from '../../utils/orderFormUtils';
import { checkIfStringEmptyOrUndefined, checkIfStringIsComposedByWhiteSpaceOnly } from '../../utils/validations';
import authAxios from '../../authorization/axios';

interface OrderFormProps extends WithTranslation {
  match: any,
  order?: Order;
}



interface IOrderFormState {
  order_id?: number,
  order: Order,
  subtotalRefund: number,
  vatRefund: number,
  toShipItems: number,
  shippeditems: number,
  editBilling: boolean,
  editShippings: { [key: string]: boolean | { isFirst: true; }; },
  productTypes: any[],
  paymentTypes: any[],
  loading?: boolean,
  currencySymbol: string,
  shippings: {
    showModal: boolean,
    contact?: Contact,
    location?: Location,
    items: any[];
  }[],
  // paymentGeneration: PaymentGeneration;
  payments: OrderPayment[]
}

const OrderForm = (props: OrderFormProps) => {
  const { t } = useTranslation();
  const ordersService: OrdersService = new OrdersService();

  const [order, setOrder] = useState({
    order_id: props.match.params.id ? parseInt(props.match.params.id) : undefined,
    order: props.order || new Order()
  });
  const [productTypes, setProductTypes] = useState<IOrderFormState['productTypes']>([]);
  const [paymentTypes, setPaymentTypes] = useState<IOrderFormState['paymentTypes']>([]);
  const [loading, setLoading] = useState<IOrderFormState['loading']>(false);
  console.log(loading);
  const [shippings, setShippings] = useState<IOrderFormState['shippings']>([]);
  console.log(shippings);
  const [currencySymbol, setCurrencySymbol] = useState<IOrderFormState['currencySymbol']>('');
  const [payments, setPayments] = useState<IOrderFormState['payments']>([]);


  // on comp first render only
  useEffect(() => {
    if (order?.order_id !== undefined && order?.order_id > 0) {
      const getOrder = async () => {
        const resultOrder = await authAxios.get(`${constants.api.getOrder}/${order.order_id}`);
        if (resultOrder.data && resultOrder.data.data) {
          const ord = resultOrder.data.data;
          const currSym = OrderFormUtils.getCurrecy(ord.currency || 'NO-CURRENCY');

          setOrder({ ...order, order: ord });
          setShippings( ord.shippings || [] );
          setCurrencySymbol(currSym);
        }
      };
      getOrder();
    }
    const getProductTypes = async () => {
      const productsTypesResult = await authAxios.get(`${constants.api.getProductTypes}`);
      if (productsTypesResult.data && productsTypesResult.data.data) {
        setProductTypes( productsTypesResult.data.data );
      }
    };
    getProductTypes();

    const getPaymentTypes = async () => {
      const paymentTypesResult = await authAxios.get(`${constants.api.getPaymentTypes}`);
      if (paymentTypesResult.data && paymentTypesResult.data.data) {
        setPaymentTypes( paymentTypesResult.data.data );
      }
    };
    getPaymentTypes();
  }, []);

  //on update
  useEffect(() => {
    if (props.match.params.id !== '0') {
      authAxios.get(`${constants.api.getOrder}/${props.match.params.id}`).then((res) => {
        if (res.data && res.data.data) {
          const ord = res.data.data;
          setOrder({ ...order, order: ord });
          setShippings( ord.shippings || [] );
        }
      });
    } else {
      setOrder({ order_id: 0, order: new Order() });
      setShippings( [] );
    }
  }, [props.match.params.id]);

  const isValidOrder = () => {
    const ord = order.order;
    const errors: string[] = [];

    if (checkIfStringEmptyOrUndefined(ord.order_id)) {
      errors.push(t('VALIDATION_REQUIRED', { field: t('ORDER_DETAILS') }));
    } else if (ord.order_id !== undefined && checkIfStringIsComposedByWhiteSpaceOnly(ord?.order_id)) {
      errors.push(t('VALIDATION_NO_ONLY_WHITE_SPACE', { field: t('ORDER_DETAILS') }));
    } else if (order.order_id !== undefined && ord?.order_id?.includes(' ')) {
      errors.push(t('VALIDATION_NO_WHITE_SPACE', { field: t('ORDER_DETAILS') }));
    }

    if (checkIfStringEmptyOrUndefined(ord.order_code)) {
      errors.push(t('VALIDATION_REQUIRED', { field: t('ORDER_CODE') }));
    } else if (ord.order_code !== undefined && checkIfStringIsComposedByWhiteSpaceOnly(ord.order_code)) {
      errors.push(t('VALIDATION_NO_ONLY_WHITE_SPACE', { field: t('ORDER_CODE') }));
    } else if (ord.order_code !== undefined && ord.order_code.includes(' ')) {
      errors.push(t('VALIDATION_NO_WHITE_SPACE', { field: t('ORDER_CODE') }));
    }

    if (ord.date === undefined) {
      errors.push(t('VALIDATION_REQUIRED', { field: t('ORDER_DATE') }));
    }

    if (checkIfStringEmptyOrUndefined(ord.source)) {
      errors.push(t('VALIDATION_REQUIRED', { field: t('SOURCE') }));
    } else if (ord.source !== undefined && checkIfStringIsComposedByWhiteSpaceOnly(ord.source)) {
      errors.push(t('VALIDATION_NO_ONLY_WHITE_SPACE', { field: t('SOURCE') }));
    }

    if (ord.total === undefined) {
      errors.push(t('VALIDATION_REQUIRED', { field: t('ORDER_TOTAL') }));
    }
    if (ord.total < 0) {
      errors.push(t('VALIDATION_NUMBER_MIN', { min: 0, field: t('ORDER_TOTAL') }));
    }

    if (ord.vat === undefined) {
      errors.push(t('VALIDATION_REQUIRED', { field: t('VAT') }));
    }
    if (ord.vat < 0) {
      errors.push(t('VALIDATION_NUMBER_MIN', { min: 0, field: t('VAT') }));
    }

    if (ord.orderProducts.length === 0) {
      errors.push(t('VALIDATION_ORDER_PRODUCTS_LENGTH'));
    }

    if (!ord.billing && ord.Billing) {
      if (!ord.Billing.address && checkIfStringEmptyOrUndefined(ord.Billing.address)) {
        errors.push(t('VALIDATION_REQUIRED', { field: t('ADDRESS') }));
      }
      if (!ord.Billing.city && checkIfStringEmptyOrUndefined(ord.Billing.city)) {
        errors.push(t('VALIDATION_REQUIRED', { field: t('CITY') }));
      }
      if (!ord.Billing.country && checkIfStringEmptyOrUndefined(ord.Billing.country)) {
        errors.push(t('VALIDATION_REQUIRED', { field: t('COUNTRY') }));
      }
      if (!ord.Billing.postcode && checkIfStringEmptyOrUndefined(ord.Billing.postcode)) {
        errors.push(t('VALIDATION_REQUIRED', { field: t('POSTAL_CODE') }));
      }
      if (!ord.Billing.province && checkIfStringEmptyOrUndefined(ord.Billing.province)) {
        errors.push(t('VALIDATION_REQUIRED', { field: t('PROVINCE') }));
      }
      if (!ord.Billing.contact_id && ord.Billing.contact) {
        if (!ord.Billing.contact.mail) {
          errors.push(t('VALIDATION_REQUIRED', { field: t('EMAIL') }));
        }
      }
    }

    if (!ord.billing && !ord.Billing) {
      errors.push(t('VALIDATION_REQUIRED', { field: t('BILLING') }));
    }

    if (errors.length > 0) {
      notification.error({
        message: `${t('VALIDATION_ERRORS')}:`,
        description: <ul className='dashed'>{errors.map(e => <li key={e}>{e}</li>)}</ul>,
        placement: 'bottomRight',
        duration: 30000,
        style: {
          width: '450px'
        }
      });
      return false;
    }
    return true;
  };

  const save = async () => {
    setLoading( true );
    const ord: Order = JSON.parse(JSON.stringify(order.order));

    if (ord.Billing?.id) {
      ord.billing = ord.Billing?.id;
    }

    const billing = (ord.Billing?.id || 0) > 0 ? undefined : ord.Billing;
    const contact = (ord.Billing?.contact?.id || 0) > 0 ? undefined : ord.Billing?.contact;
    if (!isValidOrder()) {
      setLoading( false );
      return;
    }
    let call = undefined;
    if (ord.id) {
      call = ordersService.update(ord, ord.orderProducts, billing, contact, ord.shippings);
    } else {
      call = ordersService.create(ord, ord.orderProducts, billing, contact, ord.shippings, payments);
    }

    call.then(result => {
      setLoading( false );
      if (result.success) {
        message.success({
          duration: 2.5,
          content: t('ORDER_SAVED'),
          style: {
            marginTop: 100
          }
        });
        setTimeout(() => {
          (props as any).history.push({ pathname: '/purchases' });
        }, 3000);
        return;
      }
      message.error({
        content: <div style={{ whiteSpace: 'pre' }}>
          {t('ORDER_NOT_SAVED')}:
          {result.errorMessage}
        </div>,
        style: {
          marginTop: 100
        }
      });
    }).catch(err => {
      setLoading( false );
      message.error({
        content: `${t('ORDER_NOT_SAVED')}: ${err.response?.data.errorMessage}`,
        style: {
          marginTop: 100
        }
      });
    });
  };

  const orderUpdated = (ord: Order) => {
    console.log('Order updated', ord);
    setOrder({ ...order, order: ord });
  };

  /* unused
  const onShippingsChange = () => {
    const order = order.order;
    setState({ ...state, order });
  };
*/
  const paymentUpdated = (updatedPayments: OrderPayment[]) => {
    setPayments(updatedPayments);
  };


  return (
    <>
      <Loader visible={loading} fullscreen={true} />
      {
        /* HEADER */
        <OrderFormHeader
          orderUpdated={orderUpdated.bind(this)}
          order={order.order}
          paymentTypes={paymentTypes}
          currencySymbol={currencySymbol}
          onCurrencyChange={(currency) => {
            const currSym = OrderFormUtils.getCurrecy(currency);
            setCurrencySymbol( currSym );
          }}
        />
      }
      {
        /* BODY */
        <div className='fullTablesContainer'>
          <div className='tablesContainer mt-1 mb-2 mx-auto justify-content-center d-flex flex-column'>
            {/* BILLING AND ITEMS TABLE */}
            <OrderFormBody
              paymentUpdated={paymentUpdated.bind(this)}
              orderUpdated={orderUpdated.bind(this)}
              currencySymbol={currencySymbol}
              productTypes={productTypes}
              paymentTypes={paymentTypes}
              order={order.order}
            />
            <div style={{ marginTop: '2em' }}>
              <div className='float-right'>
                {/* <Checkbox >{this.t('SEND_AUTOMATIC_EMAIL')}</Checkbox> */}
                <button className="addButton" onClick={() => save()}>
                  {t('SAVE')}
                </button>
              </div>
            </div>
          </div>
          <div className="spaceBottomTables"></div>
        </div>
      }
    </>
  );
};

export default withTranslation()(withRouter(OrderForm as any));
